// extracted by mini-css-extract-plugin
export default {"overlay":"Jg7aZgXZs8yvb7_RZGgo","modal":"mmsTqGO1fgwWVQJWsdWn","slideUp":"aVeOzPaErDM_h4RYk_44","title":"cqaGyO7E3nGj1wvjfsXx","content":"rhaYU_oVX1UwMROfEQDf"};